<template>
  <div>
    <v-btn color="success" outline small @click="generatePdf">{{
      $t("screener.stream.title.download_chat")
    }}</v-btn>
    <v-dialog v-model="dialog" hide-overlay width="400">
      <v-card :class="loading ? 'primary' : null">
        <v-card-text class="white--text" v-if="loading">
          {{ $t("screener.stream.downloading_messages") }}
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
        <v-card-text v-else>
          <v-card-title class="headline">{{
            $t("screener.stream.title.no_messages")
          }}</v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="success" outline small @click="dialog = false">{{
              $t("rms.button.ok")
            }}</v-btn>
          </v-card-actions>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import * as firebase from "firebase";

export default {
  name: "DownloadMsgs",
  data() {
    return {
      messages: {},
      is_chat_available: false,
      dialog: false,
      loading: true,
    };
  },
  computed: {
    screener() {
      return this.$store.getters["screener/getScreener"](
        this.$route.params.screener_id
      );
    },
  },
  methods: {
    async downloadChat() {
      var screener_id = this.$route.params.screener_id;
      if (screener_id == undefined) {
        return;
      }
      var messages = {};
      await firebase
        .database()
        .ref("messages")
        .child(screener_id)
        .child("messages")
        .once("value")
        .then(function (snapshot) {
          messages = snapshot.val();
        });
      return messages;
    },
    async generatePdf() {
      try {
        this.dialog = true;
        var messages = await this.downloadChat();
        if (!messages) {
          this.loading = false;
          return;
        }
        this.dialog = false;
        var rows = [["No.", "Email", "Message"]];
        var id = 0;
        for (var key in messages) {
          id++;
          rows.push([id, messages[key].user, messages[key].content]);
        }
        let csvContent = "data:text/csv;charset=utf-8,";
        rows.forEach(function (rowArray) {
          let row = rowArray.join(",");
          csvContent += row + "\r\n";
        });
        var encodedUri = encodeURI(csvContent);
        var link = document.createElement("a");
        link.setAttribute("href", encodedUri);
        link.setAttribute("download", `${this.screener.title}.csv`);
        document.body.appendChild(link); // Required for FF
        link.click();
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: "error",
        });
      }
    },
  },
};
</script>
